// extracted by mini-css-extract-plugin
export default {"image":"style_image__fkRuE","primaryImg":"style_primaryImg__15zui"};